import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import Helper from "../LocServices/Helper"
import RedirectLogin from "../LocServices/RedirectLogin"
import './search.scss'

import {
  getTags,
  getQtyLocatorRecords,
  updateSearchLoading,
  getLocatorRecords,
  updateFoundRows,
} from "../../reducers/search";

import { /* reqLocId_findInfo, 
  reset_LocIdInfo,
  update_loc_simpleFinderMode,
  update_test,
  reqLocId_edit,
  reqLocId_delete,
  update_loc_id,
  update_loc_alert */
  reqLocId_findInfo
} from "../../reducers/location";

import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import SearchContent from "./SearchContent"


const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};


class PageSearch extends Component {
  constructor(props) {
    super(props);
    this.onChangeTags = this.onChangeTags.bind(this);
    this.onChangeSearchStr= this.onChangeSearchStr.bind(this);
    this.handleSubmit= this.handleSubmit.bind(this);

    this.state = {
      //locationId: 0,
      isValidate: false,
      activeBadge: null,
      tags: '',
      searchStr: '',
    };
  }

  componentDidMount(){
    //Get Tags info
    //rdx create Thunk
    //api create axios
    //create tags element
    //make interaction
    this.props.getTags(this.props.user.chat_id, this.props.user.accessToken)
    this.props.getQtyLocatorRecords(this.props.user.chat_id, this.props.user.accessToken, '', '')
  }

  handleBadgeClick = (index) => {

    this.setState({
      activeBadge: index,
    });
    const tags = this.state.tags;
    //if (tags === null) console.log("NNul")
    const existArray = (tags === null || tags === "") ? [] : tags.split(/\s*,\s*/);
    const b = this.props.search.req_tags
    const badges = ( b !== null) ? b : []
    let newArray = []
        //if this badge exist in tagsArray -> exlude otherwise -> include
        if (existArray.includes(badges[index])) {
          //exclude element
          newArray = existArray.filter((item) => item !== badges[index])
      } else {
          //include element
          newArray = [...existArray, badges[index]]
      }
      //transform array to text again
      const v = newArray.join(', ')
      this.setState({
        tags: v
      });
      //console.log(newArray.join(', '))
      this.props.getQtyLocatorRecords(this.props.user.chat_id, this.props.user.accessToken, v, this.state.searchStr)
  };

  onChangeTags(e) {
    //console.log(e.target.value)
    const v = e.target.value.replace(/[^a-zA-Z0-9,\s]/g, "") //e.target.value.replace(/[^a-zA-Z0-9,\s]/g, "")
    this.setState({
      tags: v
    });
    this.props.getQtyLocatorRecords(this.props.user.chat_id, this.props.user.accessToken, v, this.state.searchStr)
  }

  onChangeSearchStr(e) {
    //this.props.tags(e.target.value)
    const v = e.target.value
    this.setState({
      searchStr: v,
    });
    this.props.getQtyLocatorRecords(this.props.user.chat_id, this.props.user.accessToken, this.state.tags, v)
  }

  handleSubmit(e) {
    e.preventDefault();
    //console.log("handleSubmit")
    this.props.getLocatorRecords(this.props.user.chat_id, this.props.user.accessToken, this.state.tags, this.state.searchStr)
    //console.log(this.props.user.chat_id, this.props.user.accessToken, this.state.tags, this.state.searchStr)

  }

  render() {
    //----START Auth Lost Test ------
    //console.log(this.props.search.isLoading, this.props.search.req_found_rows_qty)
    //if (!this.props.user || this.props.search.req_found_rows_qty === 0){
    if (!this.props.user ){
      window.location.href = "https://lc.tg41.uk/login";
      return null; // Return null to avoid rendering anything else
    } 
    //----END Auth Lost Test ------
    /* if (this.props.search.req_found_rows_qty === 0) return <Redirect to="/logout" />; */

    return (
      <div className="col-md-12">
      <div className="card card-container">

        <Form
          onSubmit={this.handleSubmit}
          ref={(c) => {
            this.form = c;
          }}
        >
          <div className="form-group">
            <label htmlFor="username">in Tags</label>
            <Input
              type="text"
              className="form-control"
              name="locationId"
              value={this.state.tags}
              placeholder="tag1, tag2"
              onChange={this.onChangeTags}
              /* validations={[required]} */
            />
          </div>

          <div className="form-group">
            <label htmlFor="username">in Description</label>
            <Input
              type="text"
              className="form-control"
              name="search_str"
              value={this.props.search.search_str}
              placeholder="word1 word2"
              onChange={this.onChangeSearchStr}
              /* validations={[required]} */
            />
          </div>

          <div className="form-group">
            <button
              className="btn btn-primary btn-block"
              disabled={this.props.search.isLoading}
            >
{/*               {this.state.loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )} */}
              {this.props.search.isLoading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Search <span className="search__btn--qty badge rounded-pill bg-info">{this.props.search.req_found_rows_qty}</span></span>
            </button>

          </div>
          

          <CheckButton
            style={{ display: "none" }}
            ref={(c) => {
              this.checkBtn = c;
            }}
          />
        </Form>


{/*         <button
          onClick={()=>{
            console.log("Clicked Button")
            console.log(this.props.user.chat_id, this.props.user.accessToken, this.state.tags, this.state.searchStr)
            //this.props.getQtyLocatorRecords(this.props.user.chat_id, this.props.user.accessToken, '', '')
            this.props.getQtyLocatorRecords(this.props.user.chat_id, this.props.user.accessToken, this.state.tags, this.state.searchStr)
            //window.location.href ="/locator_simple_finder/2"
            //this.props.reqLocId_findInfo(1, this.props.user.chat_id, this.props.user.accessToken)
          }}
        >Id 1</button> */}
      </div>

      {//***** Bages Kingdom *****
      this.props.search.req_tags?.length >0 && 
        <div className="card border" style={{backgroundColor: "transparent"}}>
         
          <div className="badge-container">

            <div className="badge-container__deco">
            {this.props.search.req_tags.map((badge, index) => (
                <div
                key={index}
                className={`badge ${this.state.activeBadge === index ? 'active' : ''}`}
                onClick={() => {
                  //console.log("clicked")
                  this.handleBadgeClick(index)
                }}
                >
                {badge}
                </div>
                ))}
                </div>


              </div>
            
          </div>
           }
      <SearchContent 
        req_found_rows = {this.props.search.req_found_rows}
      />

      

      <Helper 
      props={this.state}
      />
      <Helper 
      props={this.props.search}
      />

{/*       <Helper 
      props={this.props}
      /> */}
    </div>
    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    search: state.search,
    location: state.location
  };
}

  const mapDispatchToProps = { 
    getTags,
    getQtyLocatorRecords,
    updateSearchLoading,
    getLocatorRecords,
    updateFoundRows,
/*     reqLocId_findInfo,
    reset_LocIdInfo,
    update_loc_simpleFinderMode,
    update_test,
    reqLocId_edit,
    reqLocId_delete,
    update_loc_id,
    update_loc_alert */
  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(PageSearch);

//connect(mapStateToProps, mapDispatchToProps)(PageSimpleFinder);
